import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Loader = ({ message = 'Loading...', fullScreen = true }) => {
  if (fullScreen) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100vh',
          background: 'linear-gradient(135deg, #f5f0e8 0%, #e8dcc8 100%)',
          gap: 3,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #8B4513 0%, #D2691E 100%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 20px rgba(139, 69, 19, 0.3)',
          }}
        >
          <CircularProgress
            size={40}
            thickness={4}
            sx={{ color: '#fff' }}
          />
        </Box>
        <Typography
          variant="h6"
          sx={{
            color: '#5D4037',
            fontWeight: 500,
            letterSpacing: 1,
          }}
        >
          {message}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 4,
      }}
    >
      <CircularProgress sx={{ color: '#8B4513' }} />
    </Box>
  );
};

export default Loader;
